import {
  DashboardListGeneral,
  ListGeneral,
} from "Core/components";
import {generateCustomElementFromSvelteComponent} from "Core/lib/customElementGenerators";

const TestPage = generateCustomElementFromSvelteComponent (
    "TestPage",
    () => import ("Project/testpage/index.svelte"),
);

const AccountDataCard = generateCustomElementFromSvelteComponent (
    "AccountDataCard",
    () => import ("./toplevel/accountDataCard/index.svelte"),
);

const AccountList = generateCustomElementFromSvelteComponent (
    "AccountList",
    () => import ("./toplevel/accountList/index.svelte"),
);

const BackPaymentCard = generateCustomElementFromSvelteComponent (
    "BackPaymentCard",
    () => import ("./toplevel/backPaymentCard/index.svelte"),
);

const ChangePinCard = generateCustomElementFromSvelteComponent (
    "ChangePinCard",
    () => import ("./toplevel/changePinCard/index.svelte"),
);

const ChangePinTwoCard = generateCustomElementFromSvelteComponent (
    "ChangePinTwoCard",
    () => import (
        /* webpackChunkName: "changePinTwoCard" */
        "./toplevel/changePinTwoCard/index.svelte"
    ),
);

const CookieCheck = generateCustomElementFromSvelteComponent (
  "CookieCheck",
  () => import ("./toplevel/cookieCheck/index.svelte"),
);

const CreatePinTwoCard = generateCustomElementFromSvelteComponent (
    "CreatePinTwoCard",
    () => import (
        /* webpackChunkName: "createPinTwoCard" */
        "./toplevel/createPinTwoCard/index.svelte"
    ),
);

const ExtendFixAccountCard = generateCustomElementFromSvelteComponent(
    "ExtendFixAccountCard",
    () => import ("./toplevel/extendFixAccountCard/index.svelte"),
);

const FileList = generateCustomElementFromSvelteComponent(
  "FileList",
  () => import ("./toplevel/fileList/index.svelte"),
);

const FixAccountCard = generateCustomElementFromSvelteComponent(
    "FixAccountCard",
    () => import ("./toplevel/fixAccountCard/index.svelte"),
);

const FriendlyCaptcha = generateCustomElementFromSvelteComponent(
    "FriendlyCaptcha",
    () => import ("./toplevel/friendlyCaptcha/index.svelte"),
);

const IbanOutput = generateCustomElementFromSvelteComponent (
    "IbanOutput",
    () => import (
        /* webpackChunkName: "ibanOutput" */
        "./toplevel/ibanOutput/index.svelte"
    ),
);

const LoginMenuPanel = generateCustomElementFromSvelteComponent (
    "LoginMenuPanel",
    () => import ("./toplevel/loginMenuPanel/index.svelte"),
);

const PinEntry = generateCustomElementFromSvelteComponent (
    "PinEntry",
    () => import ("./toplevel/pinEntry/index.svelte"),
);

const OrderOverviewList = generateCustomElementFromSvelteComponent (
    "OrderOverviewList",
    () => import (
        /* webpackChunkName: "orderOverviewList" */
        "./toplevel/orderOverviewList/index.svelte"
    ),
);

const RequestFormularCard = generateCustomElementFromSvelteComponent (
    "RequestFormularCard",
    () => import ("./toplevel/requestFormularCard/index.svelte"),
);

const RequestMenuPanel = generateCustomElementFromSvelteComponent (
    "RequestMenuPanel",
    () => import ("./toplevel/requestMenuPanel/index.svelte"),
);

const ResetPinCard = generateCustomElementFromSvelteComponent (
    "ResetPinCard",
    () => import("./toplevel/resetPinCard/index.svelte"),
);

const SalesOverviewList = generateCustomElementFromSvelteComponent (
    "SalesOverviewList",
    () => import ("./toplevel/salesOverviewList/index.svelte"),
);

const PinOneAllocationCard = generateCustomElementFromSvelteComponent (
    "PinOneAllocationCard",
    () => import(
        /* webpackChunkName: "pinOneAllocationCard" */
        "./toplevel/pinOneAllocationCard/index.svelte"
    ),
);

const SecurityQuestionCard = generateCustomElementFromSvelteComponent (
    "SecurityQuestionCard",
    () => import ("./toplevel/securityQuestionCard/index.svelte"),
);

const Scrollbar = generateCustomElementFromSvelteComponent (
    "Scrollbar",
    () => import ("./toplevel/scrollbar/index.svelte"),
);

const ReaderMessage = generateCustomElementFromSvelteComponent (
    "ReaderMessage",
    () => import ("./toplevel/readerMessage/index.svelte"),
);

const components = [
  ["test-page", TestPage],
  ["account-data-card", AccountDataCard],
  ["account-list", AccountList],
  ["back-payment-card", BackPaymentCard],
  ["change-pin-card", ChangePinCard],
  ["change-pin-two-card", ChangePinTwoCard],
  ["cookie-check", CookieCheck],
  ["create-pin-two-card", CreatePinTwoCard],
  ["dashboard-list-general", DashboardListGeneral],
  ["extend-fixaccount-card", ExtendFixAccountCard],
  ["file-list", FileList],
  ["fix-account-card", FixAccountCard],
  ["friendly-captcha", FriendlyCaptcha],
  ["iban-output", IbanOutput],
  ["list-general", ListGeneral],
  ["login-menu-panel", LoginMenuPanel],
  ["order-overview-list", OrderOverviewList],
  ["pin-entry", PinEntry],
  ["pin-one-allocation-card", PinOneAllocationCard],
  ["request-formular-card", RequestFormularCard],
  ["request-menu-panel", RequestMenuPanel],
  ["reset-pin-card", ResetPinCard],
  ["sales-overview-list", SalesOverviewList],
  ["security-question-card", SecurityQuestionCard],
  ["scroll-bar", Scrollbar],
  ["reader-message", ReaderMessage],
];

export default components;

